<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import TwCreateFilter from '../components/TwCreateFilter';
import TwDeleteFilter from '../components/TwDeleteFilter';
import TwTitleBar from '../components/TwTitleBar';
import store from '../store';

export default {
  components: {
    TwCreateFilter,
    TwDeleteFilter,
    TwTitleBar,
  },
  data() {
    return {
      breadcrumbs: [
        { text: 'Web content', to: '', disabled: true },
        { text: this.$t('filterList.title'), to: { name: 'FilterList' } },
      ],
      headers: [
        { text: this.$t('filterList.dataHeaders.name'), value: 'name', width: '250px' },
        { text: this.$t('filterList.dataHeaders.product'), value: 'product.name' },
        { text: this.$t('filterList.dataHeaders.brands'), sortable: false },
        { text: this.$t('filterList.dataHeaders.updatedBy'), value: 'user.firstName' },
        { text: this.$t('filterList.dataHeaders.updatedAt'), value: 'updatedAt' },
        { text: this.$t('filterList.dataHeaders.createdAt'), value: 'createdAt' },
        { sortable: false },
      ],
      filter: '',
      pagination: {
        rowsPerPage: 10,
        descending: true,
        sortBy: 'updatedAt',
      },
      paginationLevels: [
        10,
        20,
        100,
        {
          text: '$vuetify.dataIterator.rowsPerPageAll',
          value: -1,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.filter.list.listLoading,
      brands: state => state.app.auth.brands,
      products: state => state.app.auth.products,
      selectedBrands: state => state.filter.list.brands,
      selectedProducts: state => state.filter.list.products,
    }),
    ...mapGetters({
      filteredFilters: 'filter/filteredFilters',
    }),
  },
  methods: {
    ...mapActions({
      fetchFilters: 'filter/fetchFilters',
      resetState: 'filter/resetState',
      setBrands: 'filter/setBrands',
      setProducts: 'filter/setProducts',
    }),
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('filter/fetchFilters')
      .then(() => {
        next();
      });
  },
};
</script>

<template>
  <div class="filter-list">
    <tw-title-bar
      :breadcrumbs="breadcrumbs"
      :title="$t('filterList.title')"/>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex grow class="pr-3">
          <v-text-field
            v-model="filter"
            clearable
            solo
            :label="$t('filterList.placeholders.search')"
            append-icon="search"
            browser-autocomplete="off"/>
        </v-flex>
        <v-flex class="pr-3" xs3>
          <v-select
            :value="selectedBrands"
            :items="brands"
            item-value="id"
            item-text="shortName"
            :label="$t('filterList.placeholders.brands')"
            append-icon="store_mall_directory"
            attach
            clearable
            solo
            multiple
            @change="setBrands($event)"/>
        </v-flex>
        <v-flex xs3 class="pr-3">
          <v-select
            :value="selectedProducts"
            :items="products"
            item-value="id"
            item-text="name"
            :label="$t('filterList.placeholders.products')"
            append-icon="local_offer"
            attach
            clearable
            solo
            multiple
            @change="setProducts($event)"/>
        </v-flex>
        <v-flex shrink>
          <div class="text-xs-right">
            <tw-create-filter
              :products="products"/>
            <v-btn
              icon
              :loading="loading"
              @click="fetchFilters">
              <v-icon>cached</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="filteredFilters || []"
          :search="filter"
          :rows-per-page-items="paginationLevels"
          :loading="loading"
          :pagination.sync="pagination">
          <template v-slot:items="props">
            <router-link
              :to="{ name: 'FilterEdit', params: { id: props.item.id } }"
              tag="tr"
              class="filter-list__tr">
              <td class="font-weight-medium">
                {{ props.item.name }}
              </td>
              <td>{{ props.item.product.name }}</td>
              <td>
                <v-chip
                  v-for="brand in props.item.brands"
                  :key="brand.shortName">
                  {{ brand.shortName }}
                </v-chip>
              </td>
              <td>{{ `${props.item.user.firstName} ${props.item.user.lastName}` }}</td>
              <td>{{ props.item.updatedAt | moment('from', 'now') }}</td>
              <td>{{ props.item.createdAt | moment('from', 'now') }}</td>
              <td class="text-xs-right">
                <tw-delete-filter
                  :id="props.item.id"
                  @deleted="fetchFilters"/>
              </td>
            </router-link>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<style lang="scss">
  .filter-list {
    &__tr {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FilterList.vue